import { graphql, useStaticQuery } from 'gatsby';

const useResourceHubComponentCollections = () => {
  const { allContentfulComponentCollection } = useStaticQuery(graphql`
    query {
      allContentfulComponentCollection(
        filter: {
          contentful_id: {
            in: [
              "4qdpCBrU5t7NqgPiiM8gJ9" #Feature Resources
              "4eLK4o6I5eqFzNPXtNev1L" #Platform
              "12Vr2eOOvDs8ysICDcqq3d" #Videos
              "1uMj9jvYR7NVkITAcXbSoA" #Groups
              "4Na0ahuSJc52SI5aG6QRri" #Subscriptions
              "1H4JNmdO0eRQv1l2qhIfGJ" #Events
              "6wohJgjUaukiyV4nLkpz1M" #Pro Products
              "2hAiBRVveqcROfGUMsWw4F" #Pro Workshops
            ]
          }
        }
      ) {
        edges {
          node {
            ...ComponentCollection
          }
        }
      }
    }
  `);

  return allContentfulComponentCollection?.edges.map((x) => x.node);
};

export default useResourceHubComponentCollections;
